/*
 * Module for configuring passkeys
*/

rs.module("content/user/profile/passkeys",

    [
        "ui/framework/passkeys",
        "controls/components/event-banner",
        "controls/list/detail"
    ],

    function (passkeys, eventBanner, listDetail) {

        //
        // Initialize
        //
        function initialize(jsSelectors, paths, allowPasskeyRegistration) {

            // Initialize passkey registration flow
            if (allowPasskeyRegistration) {
                passkeys.initializeRegistration({
                    registerButton: jsSelectors.registerButton,
                }, paths, function (error) {
                    eventBanner.removeAllMessages();
                    eventBanner.addErrorMessages(error);
                }, function () {
                    // Get the hosting list, and call reload
                    listDetail.getHostingList($.js(jsSelectors.passkeysSummary)).reload();
                }, { noRedirect: true });
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);